import { fetchVideoToken } from '@/lib/api/resources/content';

import type { Security } from '@/lib/api/types';

export type RefreshVideoTokensResult = Security;

export const setTokenInUrl = (url: string, token?: string): string => {
  if (!token) return url;

  try {
    const parsed = new URL(url);
    parsed.searchParams.set('token', token);
    return parsed.toString();
  } catch {
    return `${url}?token=${encodeURIComponent(token)}`;
  }
};

export const refreshVideoTokensWithRetry = async (
  id: string | number,
  locale: string,
  retries = 2,
): Promise<RefreshVideoTokensResult> => {
  let lastError: Error | undefined;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await refreshVideoTokens(id, locale);
    } catch (e) {
      lastError = e instanceof Error ? e : new Error(String(e));
      if (attempt < retries) {
        await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
      }
    }
  }

  throw lastError ?? new Error('Failed to refresh video tokens');
};

export const refreshVideoTokens = (
  id: string | number,
  locale: string,
): Promise<RefreshVideoTokensResult> => fetchVideoToken({ id, locale });
